import * as Dialog from "@radix-ui/react-dialog";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";

export interface ContactUpdateSuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  newContactEmail: string;
  onContinue: () => void;
}

export const ContactUpdateSuccessDialog = ({
  open,
  onOpenChange,
  newContactEmail,
  onContinue,
}: ContactUpdateSuccessDialogProps) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 z-50" />
        <Dialog.Content className="fixed left-[50%] top-[50%] z-50 w-full max-w-[480px] max-h-[90vh] translate-x-[-50%] translate-y-[-50%] bg-white rounded-2xl shadow-lg overflow-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 focus:outline-none flex flex-col">
          <div className="relative p-6 pb-0">
            <div className="flex flex-col items-center text-center gap-y-2">
              <div className="bg-pale-mint-green rounded-full size-10 flex items-center justify-center mb-2">
                <img
                  src="/assets/icons/alert-fill.svg"
                  alt=""
                  className="size-6"
                  aria-hidden
                />
              </div>
              <Dialog.Title className="font-clash-display font-semibold text-[20px] text-[#121212] leading-normal">
                Contact details updated
              </Dialog.Title>
              <Dialog.Description className="font-clash-display font-medium text-sm text-[#737373] leading-[20px]">
                Your Contact Person details have been updated successfully.
                Please use{" "}
                <span className="font-semibold">{newContactEmail}</span> to
                sign in going forward. This email address will now receive
                your login OTPs.
              </Dialog.Description>
            </div>
          </div>

          <div className="p-6">
            <PrimaryButton
              className="w-full"
              title="Go to login"
              onClick={onContinue}
            />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
